import React, { useState } from "react";

const Blogs = () => {
  const [sectionTitle] = useState("Our Work");
  const [sectionTitleText] = useState(
    "We specialize in a wide range of photography services, including Pre-Wedding, Wedding, Model Portfolios, Cinematic Films, and Product Photography, all tailored to capture your most memorable moments."
  );
  return (
    <div>
      <section>
        {/* <!-- Section Title Start --> */}
        <div>

          <div className="animate_top bb ze rj ki xn vq">
            <h2 className="fk vj pr kk wm on/5 gq/2 bb _b" style={{ paddingTop: "45px" }}>{sectionTitle}</h2>
            <p className="bb on/5 wo/5 hq">{sectionTitleText}</p>
          </div>
        </div>
        {/* <!-- Section Title End --> */}

        <div class="bb ye ki xn vq jb jo">
          <div class="wc qf pn xo zf iq">
            {/* <!-- Blog Item --> */}

            <div class="animate_top sg vk rm xm">
              <div class="c rc i z-1 pg">
                <img
                  class="w-full"
                  src="assets/images/couple/C 17.jpg"
                  alt="Blog"
                />

                <div class="im h r s df vd yc wg tc wf xf al hh/20 nl il z-10">
                  <a
                    href="/couple"
                    class="vc ek rg lk ml il gi hi"
                  >
                    See More
                  </a>
                </div>
              </div>
              <div class="yh">
                <div class="tc uf wf ag jq">
                  <div class="" style={{ margin: 'auto' }}>
                    <p className="title" style={{ color: "black", fontWeight: "bold", textAlign: "center", justifyContent: "center", fontSize: "22px" }}>Couple Shoots</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="animate_top sg vk rm xm">
              <div class="c rc i z-1 pg">
                <img
                  class="w-full"
                  src="assets/images/pre-wedding/PW 05.jpg"
                  alt="Blog"
                />

                <div class="im h r s df vd yc wg tc wf xf al hh/20 nl il z-10">
                  <a
                    href="/pre-wedding"
                    class="vc ek rg lk ml il gi hi"
                  >
                    See More
                  </a>
                </div>
              </div>
              <div class="yh">
                <div class="tc uf wf ag jq">
                  <div class="" style={{ margin: 'auto' }}>
                    <p className="title" style={{ color: "black", fontWeight: "bold", textAlign: "center", justifyContent: "center", fontSize: "22px" }}>Pre Wedding</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="animate_top sg vk rm xm">
              <div class="c rc i z-1 pg">
                <img
                  class="w-full"
                  src="assets/images/haldi/H 52.jpg"
                  alt="Blog"
                />

                <div class="im h r s df vd yc wg tc wf xf al hh/20 nl il z-10">
                  <a
                    href="/haldi"
                    class="vc ek rg lk  ml il gi hi"
                  >
                    See More
                  </a>
                </div>
              </div>
              <div class="yh">
                <div class="tc uf wf ag jq">
                  <div class="" style={{ margin: 'auto' }}>
                    <p className="title" style={{ color: "black", fontWeight: "bold", textAlign: "center", justifyContent: "center", fontSize: "22px" }}>Haldi Ceremony</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="animate_top sg vk rm xm">
              <div class="c rc i z-1 pg">
                <img
                  class="w-full"
                  src="assets/images/BABY 20.jpg"
                  alt="Blog"
                />

                <div class="im h r s df vd yc wg tc wf xf al hh/20 nl il z-10">
                  <a
                    href="/baby"
                    class="vc ek rg lk      ml il gi hi"
                  >
                    See More
                  </a>
                </div>
              </div>
              <div class="yh">
                <div class="tc uf wf ag jq">
                  <div class="" style={{ margin: 'auto' }}>
                    <p className="title" style={{ color: "black", fontWeight: "bold", textAlign: "center", justifyContent: "center", fontSize: "22px" }}>Maternity Shoots</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="animate_top sg vk rm xm">
              <div class="c rc i z-1 pg">
                <img
                  class="w-full"
                  src="assets/images/Bulk/67.jpg"
                  alt="Blog"
                />

                <div class="im h r s df vd yc wg tc wf xf al hh/20 nl il z-10">
                  <a
                    href="/bridal"
                    class="vc ek rg lk ml il gi hi"
                  >
                    See More
                  </a>
                </div>
              </div>

              <div class="yh">
                <div class="tc uf wf ag jq">
                  <div class="" style={{ margin: 'auto' }}>
                    <p className="title" style={{ color: "black", fontWeight: "bold", textAlign: "center", justifyContent: "center", fontSize: "22px" }}>Bridal Shoots</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="animate_top sg vk rm xm">
              <div class="c rc i z-1 pg">
                <img
                  class="w-full"
                  src="assets/images/model/MOD 08.jpg"
                  alt="Blog"
                />

                <div class="im h r s df vd yc wg tc wf xf al hh/20 nl il z-10">
                  <a
                    href="/model"
                    class="vc ek rg lk ml il gi hi"
                  >
                    See More
                  </a>
                </div>
              </div>

              <div class="yh">
                <div class="tc uf wf ag jq">
                  <div class="" style={{ margin: 'auto' }}>
                    <p className="title" style={{ color: "black", fontWeight: "bold", textAlign: "center", justifyContent: "center", fontSize: "22px" }}>Model Shoots</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="animate_top sg vk rm xm">
              <div class="c rc i z-1 pg">
                <img
                  class="w-full"
                  src="assets/images/Bulk/New1/26.jpg"
                  alt="Blog"
                />

                <div class="im h r s df vd yc wg tc wf xf al hh/20 nl il z-10">
                  <a
                    href="/wedding"
                    class="vc ek rg lk ml il gi hi"
                  >
                    See More
                  </a>
                </div>
              </div>

              <div class="yh">
                <div class="tc uf wf ag jq">
                  <div class="" style={{ margin: 'auto' }}>
                    <p className="title" style={{ color: "black", fontWeight: "bold", textAlign: "center", justifyContent: "center", fontSize: "22px" }}>Wedding Shoots</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Testimonial Section */}
      <div className="testimonial-section" style={{ textAlign: 'center' }}>
        <h2
          style={{
            fontSize: '30px',
            fontWeight: 'bold',
            color: 'black',
            marginBottom: '20px',
          }}
        >
          What People Say About Us
        </h2>
        <div className="new_card">
          <div
            className="elfsight-app-7e36eb69-adfb-467b-8fa3-cabcbec7ee55"
            data-elfsight-app-lazy
          ></div>
        </div>
      </div>

      {/* Internal CSS to make the testimonial section responsive */}
      <style jsx>{`
        /* Default styles */
        .testimonial-section h2 {
          font-size: 30px;
        }

        /* Media query for mobile screens */
        @media (max-width: 768px) {
          .testimonial-section h2 {
            font-size: 24px; /* Slightly smaller font size on mobile */
            margin-bottom: 15px;
          }

          .new_card {
            margin: 0 10px; /* Add some padding for better mobile view */
          }

          /* If you want to control the layout of the Elfsight app widget */
          .elfsight-app-7e36eb69-adfb-467b-8fa3-cabcbec7ee55 {
            width: 100%; /* Ensure widget fits within the screen */
            height: auto; /* Adjust height as needed */
          }
        }
      `}</style>


    </div>
  );
};

export default Blogs;
